import React from 'react'
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const Maintanance = () => {
  return (
    <div className={tw`border-2 border-gray-400 w-2/3 mx-auto my-20 px-2 py-4 text-lg `} style={{boxShadow:" 0px 3px 3px 2px gray"}}>
      <div>
        <p>We're Currently Performing Scheduled Maintenance<br/>We are currently performing essential maintenance to improve our services.During this time, our software will be temporarily unavailable. We apologize for any inconvenience this may cause.</p>
        <p>Maintenance Details:
          <ul className={tw`list-disc px-4`} >
            <li>Start time:&#91;&#93;</li>
            <li>Estimated End time:&#91;&#93;</li>
            <li>Impact:&#91;"All funcionalities will be temporarily unavailable."&#93;</li>
          </ul>
        </p>
        <p>What to Expect:
          <ul className={tw`list-disc px-4`}>
            <li>Access:You will not be able to access the software during this maintenance period.</li>
            <li>
              Updates:we will notify you once maintenance is completed and services are restored.
            </li>
          </ul>
        </p>

      </div>
    </div>
  )
}

export default Maintanance
